import React, { useId } from 'react'

interface CryptoWebIconProps {
  className?: string
}

export const CryptoWebIcon: React.FC<CryptoWebIconProps> = ({ className }) => {
  const id = useId()
  const paint0Id = `paint0_linear_${id}`
  const paint1Id = `paint1_linear_${id}`
  const paint2Id = `paint2_linear_${id}`

  return (
    <svg viewBox="0 0 24 24" fill="none" className={className}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.12 17.29C14.82 16.12 15.28 14.42 15.28 12.50C15.28 10.58 14.82 8.88 14.12 7.71C13.41 6.51 12.57 6 11.83 6C11.10 6 10.26 6.51 9.55 7.71C8.85 8.88 8.39 10.58 8.39 12.50C8.39 14.42 8.85 16.12 9.55 17.29C10.26 18.49 11.10 19 11.83 19C12.57 19 13.41 18.49 14.12 17.29ZM11.83 20C14.29 20 16.28 16.64 16.28 12.50C16.28 8.36 14.29 5 11.83 5C9.38 5 7.39 8.36 7.39 12.50C7.39 16.64 9.38 20 11.83 20Z"
        fill={`url(#${paint0Id})`}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.72 11.13C16.99 10.58 14.57 10.22 11.83 10.22C9.10 10.22 6.67 10.58 4.95 11.13C4.09 11.41 3.46 11.72 3.07 12.02C2.67 12.33 2.67 12.50 2.67 12.50C2.67 12.50 2.67 12.67 3.07 12.98C3.46 13.28 4.09 13.59 4.95 13.87C6.67 14.42 9.10 14.78 11.83 14.78C14.57 14.78 17.00 14.42 18.72 13.87C19.58 13.59 20.21 13.28 20.59 12.98C21.00 12.67 21.00 12.50 21.00 12.50C21.00 12.50 21.00 12.33 20.59 12.02C20.21 11.72 19.58 11.41 18.72 11.13ZM22.00 12.50C22.00 10.69 17.45 9.22 11.83 9.22C6.22 9.22 1.67 10.69 1.67 12.50C1.67 14.31 6.22 15.78 11.83 15.78C17.45 15.78 22.00 14.31 22.00 12.50Z"
        fill={`url(#${paint1Id})`}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.62 18.61C17.59 20.10 14.83 21 11.83 21C8.83 21 6.08 20.10 4.05 18.61C2.02 17.11 0.67 14.96 0.67 12.50C0.67 10.04 2.02 7.89 4.05 6.39C6.08 4.90 8.83 4 11.83 4C14.83 4 17.59 4.90 19.62 6.39C21.64 7.89 23.00 10.04 23.00 12.50C23.00 14.96 21.64 17.11 19.62 18.61ZM11.83 20C17.45 20 22.00 16.64 22.00 12.50C22.00 8.36 17.45 5 11.83 5C6.22 5 1.67 8.36 1.67 12.50C1.67 16.64 6.22 20 11.83 20Z"
        fill={`url(#${paint2Id})`}
      />
      <defs>
        <linearGradient
          id={paint0Id}
          x1="11.83"
          y1="8.67"
          x2="11.83"
          y2="20"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id={paint1Id}
          x1="13.58"
          y1="15.67"
          x2="13.58"
          y2="5.33"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id={paint2Id}
          x1="11.83"
          y1="3.17"
          x2="11.83"
          y2="22.33"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  )
}
